import React from "react";
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from "./containers/App"
import { createHttpLink } from 'apollo-link-http'
import { onError } from "apollo-link-error";
import { setContext } from 'apollo-link-context'
import { split } from '@apollo/client/link/core';
import { ApolloClient, ApolloProvider, InMemoryCache, ApolloLink } from "@apollo/react-hooks";
import { AUTH_TOKEN } from './constants'

import "./index.scss";
import { BrowserRouter } from 'react-router-dom';
import { publicOperations } from "./queries/Queries";

const authLink = setContext((_, { headers }) => {
    const token = localStorage.getItem(AUTH_TOKEN)
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : ''
      }
    }
  })

const httpLink = createHttpLink({
    uri: `${process.env.REACT_APP_BACKEND_URL}/graphql`
})
  
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, extensions }) => 
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${extensions.code}`
      )
    );
  if (networkError) {
    console.log(`[Network error]: ${networkError}`);
    // props.history.push('/network-error') // redirect to network-error route
  }
});


function splitLink() {
  return split(
    ({ operationName }) => publicOperations.includes(operationName),
    httpLink,
    authLink.concat(httpLink)
  );
} 

const client = new ApolloClient({
    link: ApolloLink.from([errorLink, splitLink()]),
    cache: new InMemoryCache()
})

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <BrowserRouter>
      <ApolloProvider client={client}>
          <App />
      </ApolloProvider>
    </BrowserRouter>
  </StrictMode>
);